import React, { FC } from 'react';
import { GateGeometry, MapPopupMoveable } from '@ems/client-design-system';
import { IGateCoordinateObject } from 'src/utils/spatialFeatureHelpers/interfaces';
import { GateGeometryType } from 'src/app/gql/__generated__/hooks';

interface IMapGatesProps {
  selectedGateCoordinates: {
    id: number;
    name: string;
    geometry?: GateGeometryType;
  }[];
  mapZoom: number;
  isEditable?: boolean;
}

export const MapGates: FC<IMapGatesProps> = ({
  selectedGateCoordinates,
  mapZoom,
  isEditable = false,
}) => (
  <>
    {selectedGateCoordinates.map(gate => (
      <GateGeometry
        key={gate.id}
        coordinates={gate.geometry as IGateCoordinateObject}
        gateName={gate.name}
        mapZoom={mapZoom}
        isEditable={isEditable}
        scaleByZoom
      />
    ))}
    {selectedGateCoordinates.map(gate => (
      <MapPopupMoveable
        key={`popup-${gate.id}`}
        anchorLine={true}
        anchorMarker={false}
        offsetLeft={15}
        offsetTop={15}
        latitude={gate.geometry.anchorPosition.latitude}
        longitude={gate.geometry.anchorPosition.longitude}
        draggable={true}
        onClose={() => {}}
        canBeClosed={false}
        className={'gate-popup'}>
        {gate.name}
      </MapPopupMoveable>
    ))}
  </>
);
